import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import { CheckCircle, Cancel, HourglassFull } from "@mui/icons-material";


const ExistingTable = ({ data }) => {

    const columns = [
        {
            field: "matricola",
            headerName: "SERIAL NUMBER",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "mac",
            headerName: "MAC ADDRESS",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "dataProduzione",
            headerName: "PRODUCTION DATE (UTC +1)",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "isActive",
            headerName: "IS ACTIVE",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
              return (
                  params.value === 2 ? <CheckCircle style={{ color: 'green' }} /> :
                  params.value === 1 ? <HourglassFull style={{ color: 'orange' }} /> :
                  <Cancel style={{ color: 'red' }} />
              );
          }
          
        },
    ]

    return (
        <>
            <Box height="93.5%">
                <DataGrid
                    sx={{
                        fontWeight: 900,
                        height: "100%",
                        width: "100%",
                        borderRadius: 5,
                        border: "solid 1px #459095",
                        overflowX: "auto",
                        "& .MuiDataGrid-root": {
                          border: "none",
                          backgroundColor: "transparent !important"
                        },
                        "& .MuiDataGrid-cell": {
                          borderBottom: "none",
                        },
                        "& .name-column--cell": {
                          color: "#1D7B91",
                          fontWeight: 900
                        },
                        "& .MuiDataGrid-toolbarContainer": {
                          borderTopRightRadius: 17,
                          borderTopLeftRadius: 17,
                          gap: 4,
                          backgroundColor: "#449095",
                          color: "#1D7B91",
                        },
                        "& .MuiDataGrid-footerContainer": {
                          borderTop: "none",
                          backgroundColor: "#449095",
                          borderBottomLeftRadius: 20,
                          borderBottomRightRadius: 20
                        },
                        "& .MuiCheckbox-root": {
                          color: "#1D7B91 !important",
                        },
                        "& .MuiButtonBase-root": {
                          color: "#fff !important",
                        },
                        "& .MuiCircularProgress-root": {
                          color: "#5b9ba9 !important"
                        },
                        "& .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell": {
                          whiteSpace: "normal !important"
                        },
                        "& .MuiBadge-badge": {
                          backgroundColor: '#dd8d16'
                        },
                        "& .MuiDataGrid-root .MuiDataGrid-container--bottom [role=row]": {
                          background: "#D0D0D0 !important"
                        },
                        "& .MuiDataGrid-panelWrapper": {
                          width: '600px !important'
                        },
                        "& .MuiDataGrid-overlayWrapperInner": {
                          backgroundColor: '#1a1a1a !important'
                        },
                        "& .MuiDataGrid-virtualScrollerContent": {
                          backgroundColor: '#1a1a1a !important'
                        },
                        "& .MuiDataGrid-filler": {
                          backgroundColor: '#1a1a1a !important'
                        },
                        "& .MuiDataGrid-columnHeaderTitle": {
                          fontWeight: 900
                        },
                        "& .MuiDataGrid-virtualScroller": {
                          borderRadius: 0
                        },
                        "& .MuiDataGrid-columnHeader": {
                          backgroundColor: "#449095",
                        },
                      }}
                      hideFooter={true}
                      rows={data ? data : []}
                      columns={columns}
                      slots={{ toolbar: GridToolbar }}
                      slotProps={{
                        toolbar: {
                          printOptions: { disableToolbarButton: true },
                        },
                      }} />
            </Box>
        </>
    );
}

export default ExistingTable;
